import { createContext } from "react";
const Carro = createContext(null);
export default Carro;